




































import Vue from "vue";

import DataIcon from "@/assets/icons/data-light.svg";
import DiagIcon from "@/assets/icons/diag-light.svg";
import StateIcon from "@/assets/icons/state-light.svg";

import "bootstrap/dist/css/bootstrap.min.css";

export default Vue.extend({
  data() {
    return {
      navigationItems: [
        {
          alt: "Data",
          icon: DataIcon,
          text: "System Data",
          to: "data",
        },
        {
          alt: "State",
          icon: StateIcon,
          text: "System State",
          to: "state",
        },
        {
          alt: "Diagnostics",
          icon: DiagIcon,
          text: "Diagnostics Manager",
          to: "diagnostics",
        },
      ],
    };
  },
});
